import DoxAnalyticsMarkup from '../dox_analytics_markup';

// Sets up and exposes both window.DoxAnalyticsMarkup and window.DoxAnalytics
(function () {
  if (window.DoxAnalyticsMarkup) return;

  window.DoxAnalyticsMarkup = new DoxAnalyticsMarkup(window.document);
  if (!window.DoxAnalytics) window.DoxAnalytics = window.DoxAnalyticsMarkup.da;
})();
